export const handleAsyncScrollToTop = (timeout = 250) => {
  setTimeout(() => {
    window.scrollTo({ behavior: 'smooth', top: 0 })
  }, timeout)
}
